import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Providers extends CommonCRUD {}

export default Providers;
